module.exports = __webpack_public_path__ + "img/data-table-light-01.11bf8725.jpg";